import { SubscriptionPlan } from '@vi-iot/client';
export interface InstallationFeature<T> {
  name: string;
  value?: T;
  valueSpecification?: {
    [key: string]: {
      min?: number;
      max?: number;
      stepping?: number;
      values?: any[];
    };
  };
  _links?: any[];
}

export interface InstallationPackageStatus {
  plan: SubscriptionPlan;
  boilerSerial?: string;
  isTrial?: boolean;
}

export enum InstallationsFilterType {
  All = 'all',
  Error = 'error',
  Maintenance = 'maintenance',
  Offline = 'offline',
  Working = 'working',
  RemoteDiagnostic = 'remoteDiagnostic',
  ColdSystem = 'coldSystem',
}

export const defaultPageSize = 10;
